import React from 'react'
import MinesGames from '../components/Mines'

const Activity = ({ balance,setBalance }) => {
  return (
    <div>
      <MinesGames balance={balance} setBalance={setBalance}/>
    </div>
  )
}

export default Activity